import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=ac155324&scoped=true&"
import script from "./TeachersTable.vue?vue&type=script&lang=js&"
export * from "./TeachersTable.vue?vue&type=script&lang=js&"
import style0 from "./TeachersTable.vue?vue&type=style&index=0&id=ac155324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac155324",
  null
  
)

export default component.exports